import {EsquireClient} from "@/types/clients/esquire";
import ReservationLoginPayload from "@/types/clients/esquire/payloads/reservation-login-payload";
import {AuthError} from "@/services/auth-errors";

export default class ReservationLogIn {
  constructor(private client: EsquireClient) {}

  public async send(payload: ReservationLoginPayload): Promise<string> {
    const response = await this.client.fetch(
      (baseUrl) => new URL("api/v1/reservations/guest-app-email", baseUrl), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload.toJson())
      }
    );


    if (response.status === 403) throw new AuthError("forbidden");
    if (!response.ok) throw new Error("reservation_login_failed");

    return response.json();
  }
}
